import { Tag } from "antd";
import moment from "moment";
import { EstimateStatus } from "utils/types/estimateTypesNew";

interface EstimateTagProps {
    status: EstimateStatus;
    approvedDate: number | null;
}
export const EstimateTag = ({ status, approvedDate }: EstimateTagProps) => {
    const tagLibrary: {
        [key in EstimateStatus]: {
            color: string;
            title: string;
        };
    } = {
        draft: {
            color: 'volcano',
            title: 'Draft',
        },
        sent: {
            color: 'purple',
            title: 'Pending Approval',
        },
        declined: {
            color: 'blue',
            title: 'Declined',
        },
        approved: {
            color: 'green',
            title: 'Approved',
        },
    };

    const { color, title } = tagLibrary[status];
    let displayTitle = title;
    if (status === 'approved' && approvedDate){
        const dateString = moment.unix(approvedDate).format("MM.DD.YYYY LT");
        displayTitle = `${title} - ${dateString}`
    }
    return <Tag data-cy={'estimateStatusTag'} color={color}>{displayTitle}</Tag>;
};
